module.exports = __webpack_public_path__ + "7cef68307b4a0b40efacf7b144b75c9e.jpg";